import React from "react";

const SubheadingData = (options, fontStyle) => {
  const br = <br></br>;
  const subheading = options?.subheading ? options.subheading : "";
  if (subheading === "") {
    return <></>;
  } else {
    const text = subheading?.split("\n");
    return text ? (
      text.map((value, index) => {
        if (index != text.length) {
          return (
            <span key={index} style={subheading ? fontStyle : null}>
              {value}
              <br />
            </span>
          );
        }
      })
    ) : (
      <></>
    );
  }
};

export default function SubHeading({ options, fontStyle, idx }) {
  const heading = options?.subheading ? true : false;
  return (
    <div
      id={"subheading_" + idx}
      className={"text-[20px] main-subheading FontSIzeScale text-center"}
      style={{
        ...(heading ? fontStyle : {}),
        fontKerning: "none",
        fontFeatureSettings: '"kern" 0',
        textRendering: "geometricPrecision",
      }}
    >
      {SubheadingData(options, fontStyle)}
    </div>
  );
}
